export enum ResourceType {
    DRAWING = 'drawing',
    SAFETY_DATA_SHEET = 'safety data sheet',
    DOCUMENT = 'document',
    IMAGE = 'image',
    MISC = 'misc',
}
